const env = "https://p2y4mn09gc.execute-api.us-east-1.amazonaws.com/v1/bff";
// const env = "https://ppr.cpapi.mapfreinsurance.com/bff";
const paymentus = "https://secure2.paymentus.com";
const paymentus1 = 'https://secure1.paymentus.com';

export const environment = {
  production: false,
  env: 'ppr',
  siteKey: `6LfrR6UtAAAAAN6x0cnC6ZZ3noyRaCPSIBxj0f11`,
  backend_server_url: env,
  backend_server_url_auth: `${env}/auth/oauth/token`,
  backend_server_url_account: `${env}/b2c-account-api`,
  backend_server_url_identity: `${env}/identity-api/users`,
  backend_server_url_identity_guest: `${env}/identity-api/guest/users`,
  backend_server_url_identity_2: `${env}/identity-api`,
  backend_server_url_policy: `${env}/personal-policy-api`,
  backend_server_url_billing: `${env}/billing-api`,
  backend_server_url_claims: `${env}/claims-livo`,
  paymentus_account: `${paymentus}/cp/mapf/make-payment-express?authToken=`,
  paymentus_guest: `${paymentus}/rotp/mapf?itok=`,
  paymentus_wallet: `${paymentus}/cp/mapf/my-wallet?authToken=`,
    paymentus_add_card_to_profile: `${paymentus1}/xotp/pm/matw?authToken=`,
  paybill_link: `https://cie.paybill.com/v2/CommerceInsuranceCWEBinstallment/login.aspx`,
  paybill_tw: `https://www.paybill.com/V2/mapfreinsuranceb2c/Login.aspx`,
  paybill_base_url: `https://cie.paybill.com/`,
  guest_paybill: `https://cie.paybill.com/CommerceInsuranceInstallments`,
  loginOld: `http://b2cprdsup.mapfreinsurance.com/b2cwebapp/account/loginView?locale=en&state=MA`,
  registerOld: `http://b2cprdsup.mapfreinsurance.com/b2cwebapp/view/account?state=MA`,
  claim_doc_url: `https://claims.mapfreinsurance.com/documents/emailClaimDocuments`,
  claim_doc_url_acmic: `https://qa.claims.insure.wa.aaa.com/documents/emailClaimDocuments`,
  make_payment_url_acmic: `https://ppr.b2cacmic.mapfreinsurance.com/make-payment`,
  make_payment_url: `https://ppr.payments.mapfreinsurance.com/`,
  claim_url_acmic: `https://qa.mcr.insure.wa.aaa.com/claims/#/ReportClaim`,
  claim_url: `http://mcrppr.mapfreinsurance.com/claims/#/ReportClaim`,
  paybill_link_app: `https://cie.paybill.com/CommerceInsuranceInstallments`,
  ui_url: "https://ppr.customerportalui.mapfreinsurance.com",
  bio_url: "ppr.mapfreusa.com",
  legacy_login: "https://ppr.mapfreinsurance.com/b2cwebapp/account/login",
  dTMapfreScript: '',
  dTAcmicScript: '',
  adobeScript: 'https://assets.adobedtm.com/5de54b409272/e32ffcc056cf/launch-da035e4f1ef6-staging.min.js',
  oneIncScript:"https://stgportalone.processonepayments.com/GenericModalV2/PortalOne.js",
  OKTA: {
    MAPFRE: {
      ISSUER: "https://ppr.mysignin.mapfreinsurance.com",
      CLIENT_ID: "0oana7xnlycRS2i7w1d7",
      MOBILE_CLIENT_ID: '0oarm6hiycCWoAxlw1d7',
    },
    AAA: {
      ISSUER: "https://ppr.mysignin.b2cacmic.mapfreinsurance.com",
      CLIENT_ID: "0oaprggc4craITq1p1d7",
    }
  }
};
